import React from "react";
import { Route } from "react-router-dom";
import { RouteProps } from "react-router";
import { PermissionsEnum } from "../../constants";
import { usePermissions } from "../../hooks";

interface PermissionRouteProps extends RouteProps {
  requiredPermissions: PermissionsEnum[];
}

const PermissionRoute = ({
  requiredPermissions,
  ...remainingProps
}: PermissionRouteProps) => {
  const { hasPermission } = usePermissions();
  const canAccessRoute = requiredPermissions.every(hasPermission);

  return canAccessRoute ? <Route {...remainingProps} /> : null;
};

export default PermissionRoute;
